export default __webpack_public_path__ + "static/media/collaborative-header.289a45e5.jpg";